/**
 * Home dashboard metrics — uncached at this layer; React Query owns caching.
 */

import type { DashboardMetricsResponse } from '@/types/activity'
import { apiClient } from './client'

export const dashboard = {
  metrics: async (params: { days: number }): Promise<DashboardMetricsResponse> => {
    const response = await apiClient.get<DashboardMetricsResponse>(
      '/api/v1/dashboard/metrics',
      { params }
    )
    return response.data
  },
}
